module.exports = __webpack_public_path__ + "static/Sass-a19ee0e7c1e421129e5a7c57615dc0e2.png";